import React from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";

function View(props) {
  const { rowData, onBackClick } = props;

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>View Details</h5>
            <div className="card-header-action">
              <Link className="btn btn-underline me-2" onClick={onBackClick}>
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Row className="mb-3">
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  CER No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.cer_no || "-"}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className="mb-3">
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Plant
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.plant_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Division
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.division || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Location
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.location_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Description
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.description || "-"}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className="mb-3">
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Reason
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.reason || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Cost Reduction
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.cost_reduction || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Capacity Increase
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.capacity_increase || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  New Product
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.new_product || "-"}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className="mb-3">
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Quality
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.quality || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Replacement
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.replacement || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Environmental
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.enviromental || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Facility
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.facility || "-"}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className="mb-3">
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Other
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.other || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Capital (INR)
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.capital || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Expense (INR)
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.expense || "-"}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Expenditure Schedule
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.expenditure_schedule || "-"}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className="mb-3">
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Attachment
                </span>
                <div className="fw-medium text-sm fw-semibold">
                  {rowData.attechPath ? (
                    <a
                      href={rowData.attechPath}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={rowData.attechPath}
                        alt="Attachment"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          height: "auto",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  ) : (
                    "-"
                  )}
                </div>
              </RB.Col>
            </RB.Row>
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default View;
